document.addEventListener('DOMContentLoaded', function() {
  let bestsellerSlider = new Swiper('.bestseller-games-list', {
    loop: true,
    autoplay: false,
    slidesPerView: 6,
    speed: 700,
    grabCursor: true,
    mousewheel: true,
    keyboardControl:true,
    navigation:{
      nextEl:".similar-right",
      prevEl:".similar-left"
    }
  })

});
